import { memo } from "react";
import { useTranslation } from "@/hooks/useTranslation";

export const FormDivider = memo(function FormDivider() {
  const { t } = useTranslation();

  return (
    <div className="relative py-2">
      <div className="absolute inset-0 flex items-center">
        <div className="w-full border-t border-border"></div>
      </div>
      <div className="relative flex justify-center text-xs uppercase">
        <span className="bg-card px-3 text-muted-foreground">
          {t('auth.orContinueWith')}
        </span>
      </div>
    </div>
  );
});

